// src/config.js
export const approvedEmails = [
    'comichael.j@gmail.com',
    'mco2004brisbane@gmail.com'
  ];
  